<template>
	<div @click="handleClick(item)">
		<div class="icon">
			<div class="folderIcon" />
		</div>
		<div class="folderName">
			<span v-if="item.Name == ''">My Documents</span>
			<span class="name">{{ item.Name.replace(/\s/g,'&nbsp;') }}</span>
		</div>
		<a class="selectFolder" />
	</div>
</template>
<script>
const folderSmall = {
	emits: [`changeFolder`],
	template: `#folderSmall`,
	props: [`item`],
	methods: {
		handleClick: function (item) {
			this.$emit(`changeFolder`, item.ItemId);
		}
	}
};

export default folderSmall;
</script>